require('../../reports/_reportTitle');

jQuery(document).ready(() => {
  $('.select-denomination').select2({
    placeholder: 'Choose One',
    minimumResultsForSearch: Infinity
  });

  $('.select-state').select2({
    placeholder: 'Choose One'
  });

  $('.copyright-holder').select2({
    placeholder: 'Select Copyright'

  });

  if ($('.select-licenseType').length) {
    $('.time-report').select2({
      placeholder: 'Select Week',
      minimumResultsForSearch: Infinity,
      disabled: true
    });
  } else {
    $('.time-report').select2({
      placeholder: 'Select Week',
      minimumResultsForSearch: Infinity

    });
  }

  $('.select-services').select2({
    placeholder: 'Select services'
  });

  $('.select-licenseType').select2({
    placeholder: 'Select License Type',
    minimumResultsForSearch: Infinity
  });

  $('.select-licenseType').on('select2:select', function (e) {
    const id = $(this).find('option:selected').val();
    const timeReportSelect = $(this).closest('form').find('.time-report');
    const $this = $(this);

    timeReportSelect.select2('val', '');
    timeReportSelect.select2({
      disabled: true,
      minimumResultsForSearch: Infinity,
      placeholder: 'loading...'
    });

    $.post(loadWeeksUrl, {
      id
    }, (data) => {
      timeReportSelect.find('option').remove();

      $.each(data.weeks, (i, item) => {
        timeReportSelect.append($('<option>', {
          value: i,
          text: item
        }));
      });

      timeReportSelect.select2({
        disabled: false,
        minimumResultsForSearch: Infinity
      });

      $this.trigger('weeks-loaded');
    }, 'json');
  });

  $('.copyright-holder').change(function () {
    const select = $(this);
    const id = select.val();
    const name = select.find('option:selected').text();
    const alert = $('.alert-copyright');
    const submitBtn = $('.btn[name=submit');

    $.post(checkIfEnabledForCopyright, {
      id
    }, (data) => {
      if (!data.enabled) {
        const text = `No additional ${name} song titles are covered under the ONE LICENSE license. Manual submissions cannot be entered for the ${name} catalog.`;

        select.parent().addClass('has-error');
        alert.show();
        alert.html(text);
        submitBtn.prop('disabled', true);
      } else {
        select.parent().removeClass('has-error');
        alert.hide();
        submitBtn.prop('disabled', false);
      }
    }, 'json');
  });
});
